import { endpoints } from '../endpoints'
import { http } from '../http'
import { ObituaryMemory, ObituaryMemoryParams, PaginationParams } from '../../types'

interface ObituaryMemoriesAPI {
  create: (caseID: number, memory: ObituaryMemoryParams) => Promise<ObituaryMemory>
  load: (caseID: number | string, memoryID: number | string) => Promise<ObituaryMemory | null>
  loadAll: (
    caseID: number | string,
    paginationParams: PaginationParams,
  ) => Promise<ObituaryMemory[]>
}

export const obituaryMemories: ObituaryMemoriesAPI = {
  create: (caseID, memory) => {
    const { visitor_user, ...memoryFields } = memory
    const formData = new FormData()

    for (const name in memoryFields) {
      if (memoryFields[name]) {
        formData.append(`obituary_memory[${name}]`, memoryFields[name])
      }
    }

    for (const name in visitor_user) {
      if (visitor_user[name]) {
        formData.append(`obituary_memory[visitor_user][${name}]`, visitor_user[name])
      }
    }

    return http.multiPartPost(endpoints.obituaryMemories(caseID), formData)
  },
  load: (caseID, memoryID) => http.get(endpoints.obituaryMemory(caseID, memoryID)),
  loadAll: (caseID, { limit, page }) =>
    http.get(`${endpoints.obituaryMemories(caseID)}?limit=${limit}&page=${page}`),
}
